// knowledgeDetails.pipeline.connectors.* — owned by the connectors page.
export default {
  summary: {
    imported_one: '{{count}} source imported',
    imported_other: '{{count}} sources imported',
    failing_one: '{{count}} failing',
    failing_other: '{{count}} failing',
    running_one: '{{count}} running',
    running_other: '{{count}} running',
    notAuthorized_one: '{{count}} provider not authorized',
    notAuthorized_other: '{{count}} providers not authorized',
  },
  stagesLabel: 'Latest run stages',
  legend: {
    title: 'Stage dots, left to right:',
    done: 'done',
    active: 'running',
    failed: 'failed',
    cancelled: 'cancelled',
    pending: 'not started',
  },
  lastSync: 'Last sync {{when}}',
  neverSynced: 'Never synced',
  latestRun: 'Latest run {{when}}',
  autoSyncOff: 'Auto-sync off',
  autoSyncNext: '{{interval}} · next {{when}}',
  autoSyncEveryMinutes: 'Every {{minutes}} minutes',
  failingFallback:
    'The latest run did not finish cleanly. See History for why.',
  openToFix: 'Open the connector to retry, or see History for why.',
  runStatus: {
    queued: 'Queued',
    running: 'Running',
    finalizing: 'Finalizing',
    cancelling: 'Cancelling',
    done: 'Done',
    completed_with_errors: 'Finished with errors',
    cancelled: 'Cancelled',
    error: 'Failed',
  },
  runKind: {
    ingest: 'Import',
    resync: 'Resync',
    retry_failed: 'Retry failed',
    reingest: 'Re-ingest',
    windowed_import: 'Full import',
    auto_sync: 'Auto-sync',
  },
  documentsIndexed: '{{indexed}} of {{expected}} documents indexed',
  chunksFromRun: '{{chunks}} chunks',
  notAuthorized: 'Not authorized',
  authorize: 'Authorize in Connectors',
  authorizeHint:
    'No account authorized for this workspace yet. Authorizing happens once, outside this knowledge base.',
  connectAnother: 'Connect another source in Connectors',
  oneConnector:
    'This knowledge base imports from {{name}}. A knowledge base can use one connector; create another knowledge base for this one.',
  gitlabName: 'GitLab (code)',
  gitlabDesc: 'Connect a GitLab server to ingest code.',
  schemaFetched: 'Schema fetched',
  schemaNotFetched: 'Not fetched',
  schemaSaved: 'Schema saved to knowledge base',
  schemaSaveFailed: 'Failed to save schema to knowledge base',
  history: {
    title: 'Run History',
    subtitle:
      'Every import into this knowledge base, newest first. Expand one for its projects and workflow, or open See details for each document.',
    connectorLabel: 'Connector',
    loading: 'Loading imports…',
    empty:
      'No imports yet. Run an import from the Connector tab to see it here.',
  },
};
